import { createApp, markRaw } from "vue";
import { createPinia } from "pinia";
import config from "./config";
import { useConfigStore } from "./stores/config";
import { init, setTag, thirdPartyErrorFilterIntegration } from "@sentry/vue";
import App from "./App.vue";
import router from "./router";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp, faChevronDown, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "./assets/css/annuities.css";
import "./assets/css/variables.css";
import { beforeSend } from "./utils/sentry";
import { getSessionId } from "./utils";
import { gbKey, initializeGrowthBook } from "./services/growthbook";

library.add(faChevronUp, faChevronDown, faArrowRight);

const app = createApp(App);
const pinia = createPinia();
pinia.use(({ store }) => { store.router = markRaw(router); });
app.use(pinia);
app.use(router);

const configStore = useConfigStore();
configStore.initialise(config);

init({
    app,
    environment: config.sentryEnvironment,
    dsn: config.sentryDsn,
    maxValueLength: 1000,
    replaysSessionSampleRate: config.sentryReplaySessionSampleRate,
    replaysOnErrorSampleRate: config.sentryReplayErrorSampleRate,
    beforeSend,
    integrations: [
        thirdPartyErrorFilterIntegration({
            filterKeys: ["annuity-ready"],
            behaviour: config.sentryThirdPartyFilterBehaviour,
        }),
    ],
});

setTag("annuity_rewrite", true);

initializeGrowthBook().then((growthBook) => {
    app.provide(gbKey, growthBook);

    app.mount("#app");
    getSessionId();
});
